import React from 'react';
import SVG from 'react-inlinesvg';

class CheckboxInput extends React.Component {
    render() {
        const {
            height: height='40px',
            width: width='40px',
            color: color='#404040',
            checked,
            } = this.props

        let imgSrc = checked?'/images/CheckboxCheck_M.svg':'/images/CheckboxEmpty_M.svg'

        return(
            <SVG style={{height: height, width: width, fill: color}}  src={imgSrc} cacheGetRequests={true} />
        );
    }
}
export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/component/Forms/CheckboxInput/index.js